import { TitreBudget } from '@components/titre-budget/models';
import { CostLevel } from '@shared/enums';
import { Block } from '@shared/models';

export const titreBudgetMock = (context: 'pose-pro' | 'pose-perso'): Block<TitreBudget> => ({
  type: 'titre-budget',
  data: {
    title: {
      text: context === 'pose-perso' ? 'Je pose moi-même [[ma cuisine]]' : 'Je fais poser',
      as: 'h1',
    },
    costLevel: context === 'pose-perso' ? CostLevel.Low : CostLevel.Medium,
  },
});
